import DynamicIcon from './Icon'

export default DynamicIcon
